import React from 'react';
import { Route, Navigate } from 'react-router-dom';

/*
 * Every route under /ebooks, in one place so App.js and the route-ranking
 * test use the same table (docs/ebook-builder/CONTRACTS.md, "web paths").
 * The static segments (new, s, …/build, …/edit) outrank :ebookId.
 *
 * `Private` wraps members-only pages (App.js's PrivateRoute). The hub and the
 * reader are public: the hub asks visitors to sign in per tab, and the
 * reader's access is decided server-side.
 */
export function ebookRoutes({ Private, pages }) {
  const { Ebooks, Wizard, Reader, Build, Editor } = pages;
  return [
    <Route key="eb-ai" path="/ebooks/ai" element={<Navigate to="/ebooks?tab=mine" replace />} />,
    <Route key="eb-new" path="/ebooks/ai/new" element={<Private><Wizard /></Private>} />,
    <Route key="eb-link" path="/ebooks/ai/s/:token" element={<Reader mode="link" />} />,
    <Route key="eb-link-chapter" path="/ebooks/ai/s/:token/chapters/:chapterId" element={<Reader mode="link" />} />,
    <Route key="eb-build" path="/ebooks/ai/:ebookId/build" element={<Private><Build /></Private>} />,
    <Route key="eb-edit" path="/ebooks/ai/:ebookId/edit" element={<Private><Editor /></Private>} />,
    <Route key="eb-view" path="/ebooks/ai/:ebookId" element={<Reader mode="ebook" />} />,
    <Route key="eb-chapter" path="/ebooks/ai/:ebookId/chapters/:chapterId" element={<Reader mode="ebook" />} />,
    <Route key="ebooks" path="/ebooks" element={<Ebooks />} />,
  ];
}
